var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('v-divider'),_c('v-container',[_c('div',{staticClass:"text-center"},[_c('h4',{staticClass:"pa-5"},[_vm._v(" サービスを利用する前にユーザー名を登録する必要があります。 ")])]),_c('user-name-setting-form')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }